export const secondary = {
  main: '#e51937',
};
